export type FlightPoint = [number, number];

export interface FlightWaypoint {
    position: FlightPoint;
    label: string;
    action: "takeoff" | "goto" | "hold" | "return" | "land";
    altitudeFt?: number;
}

export interface FlightRoute {
    waypoints: FlightWaypoint[];
}

export interface FlightTransform {
    toImageX: (x: number) => number;
    toImageY: (y: number) => number;
}

export function drawFlightPath(
    ctx: CanvasRenderingContext2D,
    route: FlightRoute,
    transform: FlightTransform
): void {
    const points = route.waypoints.map(waypoint => ({
        ...waypoint,
        x: transform.toImageX(waypoint.position[0]),
        y: transform.toImageY(waypoint.position[1])
    }));

    if (
        points.length === 0 ||
        points.some(point =>
            !Number.isFinite(point.x) ||
            !Number.isFinite(point.y)
        )
    ) {
        return;
    }

    ctx.save();

    // Draw the route between navigation points.
    if (points.length > 1) {
        ctx.beginPath();
        ctx.moveTo(points[0].x, points[0].y);

        for (const point of points.slice(1)) {
            ctx.lineTo(point.x, point.y);
        }

        ctx.strokeStyle = "#00BFFF";
        ctx.lineWidth = 3;
        ctx.setLineDash([10, 5]);
        ctx.stroke();
        ctx.setLineDash([]);
    }

    // Draw each numbered waypoint.
    points.forEach((point, index) => {
        ctx.beginPath();
        ctx.arc(point.x, point.y, 9, 0, Math.PI * 2);

        ctx.fillStyle =
            point.action === "takeoff" ? "#16A34A" :
            point.action === "land" ? "#DC2626" :
            point.action === "return" ? "#F59E0B" :
            "#0284C7";

        ctx.fill();
        ctx.strokeStyle = "#FFFFFF";
        ctx.lineWidth = 2;
        ctx.stroke();

        ctx.font = "bold 12px Arial";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillStyle = "#FFFFFF";
        ctx.fillText(String(index + 1), point.x, point.y);

        ctx.font = "bold 12px Arial";
        ctx.textAlign = "left";
        ctx.fillStyle = "#111827";
        ctx.fillText(point.label, point.x + 14, point.y - 10);
    });

    ctx.restore();
}
